// extracted by mini-css-extract-plugin
export default {"tableContainerStyles":"dispatch-history-view-module__tableContainerStyles--c1u7v"};